module.exports = __webpack_public_path__ + "85d327eb628aff1d1877b1c8b6b6f91a.svg";